import { render, staticRenderFns } from "./Honor.vue?vue&type=template&id=64ea97ee&scoped=true"
import script from "./Honor.vue?vue&type=script&lang=js"
export * from "./Honor.vue?vue&type=script&lang=js"
import style0 from "./Honor.vue?vue&type=style&index=0&id=64ea97ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ea97ee",
  null
  
)

export default component.exports